module.exports = __webpack_public_path__ + "img/ataa-hypatia.c53d2f0f.svg";